import { render, staticRenderFns } from "./ActivityHistoryDetail.vue?vue&type=template&id=38ddd26c&"
import script from "./ActivityHistoryDetail.vue?vue&type=script&lang=ts&"
export * from "./ActivityHistoryDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports